var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"deals-list",attrs:{"data-cy":"deals-list"}},_vm._l((_vm.deals),function(deal,index){return _c('deal-card',{key:deal.uid,staticClass:"deals-list__item",attrs:{"deal":deal,"highlight":_vm.highlight(deal, index)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }